// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__3V-4g","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__3WwEy"};